import React, {useEffect, useState} from 'react';
import {Container} from "react-bootstrap";
import {getRanking} from "../../services/enrollments";
import {useAuth} from "../../contexts/authContext";
import {getUnconcludedPaidRegistrations, getUnconcludedUnpaidRegistrations} from "../../services/registrations";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../components/Header";
import RankingTable from "../../components/RankingTable";
import NoRegistrationsAlert from "../../components/NoRegistrationsAlert";

const Ranking = () => {
   const [ranking, setRanking] = useState(null);
   const {user} = useAuth();
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
         let ranking = await getRanking(
             user.active_enrollment?.league_edition_id,
             user.active_enrollment?.league_id,
             user.active_enrollment?.league_category_id,
             user.active_enrollment?.league_division_id
         );

         setRanking(ranking.rankings);
      })()
   }, [user.active_enrollment]);

   if (!ranking)
      return null;

   return <div className={"Ranking"}>
      <Header class={"mb-0"} headerBarTitle={t("ranking_page.header")} showHeaderExtras/>

      {ranking.length === 0
          ? <NoRegistrationsAlert
              text={user.enrollments.length === 0 ? t("common.no_registrations") : t("ranking_page.errors.unavailable")}
          />
          : <Container className={"p-0"}>
             <RankingTable ranking={ranking}/>
          </Container>
      }
   </div>
}

export default Ranking;